
// Read if you do not know what debounce is doing
// https://davidwalsh.name/javascript-debounce-function
// Event Listner has to be called with debounce

const debounce = function (func, wait = 250, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

export default debounce



// WEBPACK FOOTER //
// ./src/AtomicUtils/debounce.js